module.exports = __webpack_public_path__ + "static/media/p3.bb065300.png";